import script from "./ChassisSectionDW5V2.vue?vue&type=script&setup=true&lang=js"
export * from "./ChassisSectionDW5V2.vue?vue&type=script&setup=true&lang=js"

import "./ChassisSectionDW5V2.vue?vue&type=style&index=0&id=338e92ef&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-338e92ef"]])

export default __exports__